var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditSignatureDarkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.621,
    height: 17.621,
    viewBox: "0 0 17.621 17.621",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2854",
    "data-name": "Group 2854",
    transform: "translate(0.75 0.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_998",
    "data-name": "Path 998",
    d: "M40.57,15.58H31.5a.769.769,0,1,0,0,1.531H40.57a.769.769,0,1,0,0-1.531Z",
    transform: "translate(-24.851 -0.973)",
    fill: "#1450ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "d",
    d: "M38.39,3.478,26.757,15.132l-.967,1.894,1.884-.967L39.327,4.425l-.947-.947ZM40.767,1.1l-.947.947.947.947.947-.947a.669.669,0,0,0,0-.947h0A.669.669,0,0,0,40.767,1.1Z",
    transform: "translate(-25.79 -0.905)",
    fill: "none",
    stroke: "#1450ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditSignatureDarkIcon);
export default __webpack_public_path__ + "static/media/edit-signature-dark-icon.3b3c835f2110950abe1609da6884b3b3.svg";
export { ForwardRef as ReactComponent };